import type { ReapproNeedAdjustmentDTO, ReapproNeedAdjustmentScope } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export interface UpsertReapproNeedAdjustmentArgs {
  categoryId: number
  scope: ReapproNeedAdjustmentScope
  storeId?: number
  deliveryDate: string
  multiplier: number
}

export const upsertReapproNeedAdjustment = async ({
  categoryId,
  scope,
  storeId,
  deliveryDate,
  multiplier,
}: UpsertReapproNeedAdjustmentArgs) => {
  const response = await gozokiApiWithAuth.post<{ adjustment: ReapproNeedAdjustmentDTO }>(
    `/reappro-categories/${categoryId}/need-adjustments`,
    { scope, storeId, deliveryDate, multiplier },
  )
  return response.data.adjustment
}

export const deleteReapproNeedAdjustment = async ({
  categoryId,
  adjustmentId,
}: {
  categoryId: number
  adjustmentId: number
}) => {
  await gozokiApiWithAuth.delete(
    `/reappro-categories/${categoryId}/need-adjustments/${adjustmentId}`,
  )
}
